import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { RouteModels } from '@share-models';

export const RouteActions = createActionGroup({
  source: 'ROUTE',
  events: {
    'Reset To Initial State': emptyProps(),
    'Set Breadcrumbs': props<{
      breadcrumbs: RouteModels.UiBreadCrumbItem[];
    }>(),
  },
});
